
import axios from "axios"

export function getStockoutRequestorDropdown (params) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/stockout/get-requestor-dropdown`, {params})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};